export var DogCategory;
(function (DogCategory) {
    DogCategory["STUD_BOYS"] = "stud-boys";
    DogCategory["SIRES"] = "sires";
    DogCategory["GIRLS"] = "girls";
    DogCategory["YOUNGSTERS"] = "youngsters";
    DogCategory["FOUNDATION_LABS"] = "foundation-labs";
    DogCategory["RETIRED_LABS"] = "retired-labs";
    DogCategory["IN_MEMORY"] = "in-memory";
})(DogCategory || (DogCategory = {}));
export var DogColor;
(function (DogColor) {
    DogColor["CHOCOLATE"] = "chocolate";
    DogColor["BLACK"] = "black";
    DogColor["YELLOW"] = "yellow";
})(DogColor || (DogColor = {}));
export var LitterType;
(function (LitterType) {
    LitterType["PLANNED"] = "planned";
    LitterType["UPCOMING"] = "upcoming";
    LitterType["PAST"] = "past";
})(LitterType || (LitterType = {}));
export var ApiResponseStatus;
(function (ApiResponseStatus) {
    ApiResponseStatus["DANGER"] = "danger";
    ApiResponseStatus["SUCCESS"] = "success";
})(ApiResponseStatus || (ApiResponseStatus = {}));
export var Month;
(function (Month) {
    Month["January"] = "January";
    Month["February"] = "February";
    Month["March"] = "March";
    Month["April"] = "April";
    Month["May"] = "May";
    Month["June"] = "June";
    Month["July"] = "July";
    Month["August"] = "August";
    Month["September"] = "September";
    Month["October"] = "October";
    Month["November"] = "November";
    Month["December"] = "December";
})(Month || (Month = {}));
